import React from 'react';

export default function NoDataHtml({ children }) {
  return <div>{children}</div>;
}
